import type { TranslationMessages } from '../types';

export const orders: TranslationMessages = {
  name: 'Order |||| Orders',
  modern: {
    version: 'Version',
    title: 'Orders',
    subtitle: 'Manage and track all orders',
    search: 'Search order number, customer, notes, table...',
    filters: 'Filters',
    export: 'Export',
    loading: 'Loading orders...',
    noOrders: 'No orders found',
    tryFilters: 'Try adjusting your filters',
    walkInCustomer: 'Walk-in Customer',
    dineIn: 'Dine-in',
    dineInTable: 'Dine-in (Table %{tableNumber})',
    noAddressOnFile: 'No address on file',
    addressNotAvailable: 'Address not available',
    items: 'items',
    noNotes: 'No notes',
    returned: 'Returned',
    columns: 'Columns',
    showColumns: 'Show Columns',
    resetColumns: 'Reset to Default',
    pagination: {
      showing: 'Showing %{start} to %{end} of %{total} results',
      previous: 'Previous',
      next: 'Next',
    },
    actions: {
      updateStatus: 'Update order status',
    },
    activeFilters: 'Active filters',
    productSummary: 'Product Summary',
    item: 'Item',
    productId: 'Product ID',
    note: 'Note',
    noItems: 'No items found',
  },
  amount: '1 order |||| %{smart_count} orders',
  title: 'Order %{reference}',
  create: 'Create Order',
  edit: 'Edit Order',
  editSuborder: 'Edit Sub Order',
  actions: {
    printBill: 'Print Bill',
    cancel: 'Cancel',
    tagCustomer: 'Tag Customer',
    clearCustomer: 'Clear customer selection',
    createCustomer: 'Create New Customer',
    createSuborder: 'Create Suborder',
    viewParentOrder: 'View Parent Order',
    ready: 'Ready',
    cancel_confirm_title: 'Cancel Order',
    cancel_confirm_message: 'Are you sure you want to cancel this order?',
    force_release: 'Force Release Table',
    checkInForBenefits: 'Check In for Benefits',
    force_release_confirm:
      'Are you sure you want to force release this table? This will make the table available regardless of other orders.',
    release_all_tables: 'Release All Tables',
    release_all_tables_title: 'Release All Tables',
    release_all_tables_message:
      'This will release all occupied tables and make them available for new orders. This action cannot be undone.',
    confirm_release_all: 'Release All Tables',
    occupied_tables_count: 'Occupied Tables (%{count})',
    no_occupied_tables: 'No occupied tables found.',
    releasing: 'Releasing...',
    print_bill: 'Print Bill',
    deliver: 'Deliver',
    addProduct: 'Add Product',
    updateProfile: 'Update Profile',
    useMaxPoints: 'Use Maximum Points',
    resetPoints: 'Reset Points',
    verifyOtp: 'Verify OTP',
    verify: 'Verify',
    selectTable: 'Select Table',
    changeTable: 'Change Table',
    fixedTables: 'Fixed Tables (1-16)',
    make_payment: 'Make Payment',
    item_status: 'Item Status',
  },
  messages: {
    loading: 'Loading',
    unknownCustomer: 'Walk-in Customer',
    noProductsFound: 'No products found',
    total: 'Total',
    totalBeforeDiscount: 'Total before discount',
    selectTableFirst: 'Please select a table first',
    verifyCustomerFirst: 'Please verify the selected customer',
    customerTaggedForMetrics:
      'Customer tagged for metrics tracking. Check in to use membership benefits.',
    customerLocked:
      'This order already has a customer and cannot be changed.',
    tagCustomerForMetrics:
      'Tag a customer to enable customer metrics tracking for this order.',
    customerTagged: 'Customer tagged successfully',
    selectTableAndCustomer: 'Please select both table and customer',
    selectProducts: 'Please select at least one product',
    enterOtp: 'Please enter OTP code to verify',
    completeProfile: 'Please complete your profile',
    qrScanFailed: 'QR scan failed',
    profileUpdateSuccess: 'Profile updated successfully',
    profileUpdateFailed: 'Profile update failed',
    checkinSuccess: 'Check-in successful',
    checkinFailed: 'Check-in failed',
    invalidOtp: 'Invalid OTP',
    otpExpired: 'OTP has expired',
    otpUsed: 'OTP has already been used',
    otpNotFound: 'OTP not found',
    checkinCooldown:
      'Please wait %{minutes} minutes before checking in again',
    customerNotFound: 'Customer not found',
    availablePoints: 'Available Points: %{points}',
    pointsValue: 'Points Value: %{value} VND',
    pointsDiscount: 'Using %{points} points (-%{value} VND)',
    remainingPoints: 'Remaining Points: %{points}',
    minPointsRedemption: 'Minimum points value must be 5,000 VND',
    exceedAvailablePoints: 'Points value cannot exceed available points',
    pointsMultipleOf1000: 'Points value must be a multiple of 1,000 VND',
    pointsRedemptionHelp:
      'Enter points to redeem (1 point = 100 VND, minimum 50 points)',
    insufficientOrderAmount:
      'Order amount must be at least 5,000 VND more than points value',
    registerForMembership: 'Register for membership to earn points',
    verifyOtp: 'Verify OTP',
    percentageExceeded: 'Percentage cannot exceed 100%',
    fixedAmountExceeded: 'Fixed amount cannot exceed total amount',
    customTableNumber: 'Custom Table Number',
    enterTableNumber: 'Enter table number (>16)',
    tableRequired: 'Table number is required for dine-in orders',
    noTableSelected: 'No table selected',
    tableOccupied: 'Table is occupied',
    noCustomer: 'No customer selected',
    orderCannotBeModified: 'This order cannot be modified',
    orderDeliveredCannotBeModified:
      'This order has been delivered and cannot be modified.',
    orderCancelledCannotBeModified:
      'This order has been cancelled and cannot be modified.',
    orderReadyCannotBeModified:
      'Orders in "ready" status cannot be modified. Create a suborder to add more items.',
    suborderCreated: 'Suborder created successfully',
    suborderCreateFailed: 'Failed to create suborder',
    noSuborders: 'No suborders yet',
    suborderEditRestriction:
      'This is a suborder. You can modify items, but other fields (customer, table, promotions, date) cannot be changed.',
    originalItem: 'Original',
    selectCustomer: 'Select a customer',
    searchCustomer: 'Search customers...',
    noCustomersFound: 'No customers found.',
    createCustomerDescription:
      'Enter the customer name to create a new customer profile.',
    enterCustomerName: 'Enter customer name',
    createCustomerError: 'Failed to create customer',
    creatingCustomer: 'Creating...',
    qrScannerPlaceholder: 'QR Scanner will be implemented here',
    scannerReady: 'Scanner ready',
    scanning: 'Scanning...',
    processing: 'Processing...',
    scannerInstructions: 'Scanner Instructions',
    pointCamera: 'Point camera at QR code',
    ensureGoodLighting: 'Ensure good lighting',
    holdSteady: 'Hold camera steady',
  },
  show: {
    title: 'Order',
  },
  fields: {
    orderInformation: 'Order Information',
    subtotal: 'Subtotal',
    date: 'Date',
    reference: 'Reference',
    items: 'Items',
    totalExTaxes: 'Total (excl. tax)',
    deliveryFees: 'Delivery Fees',
    basket: {
      delivery: 'Delivery',
      reference: 'Reference',
      quantity: 'Quantity',
      sum: 'Sum',
      tax_rate: 'Tax Rate',
      taxes: 'Tax',
      total: 'Total',
      unit_price: 'Unit Price',
    },
    address: 'Address',
    customer: 'Customer',
    firstName: 'First Name',
    lastName: 'Last Name',
    customer_id: 'Customer',
    customerPoints: 'Points: %{points}',
    date_gte: 'Passed Since',
    date_lte: 'Passed Before',
    nb_items: 'Nb Items',
    total_gte: 'Min amount',
    status: 'Status',
    returned: 'Returned',
    totalBeforeDiscount: 'Total before discount',
    discount: 'Discount',
    totalAfterDiscount: 'Total after discount',
    totalBreakdown: 'Total Breakdown',
    parentOrder: 'Parent Order',
    combinedTotal: 'Combined Total',
    totalItems: 'Total Items',
    suborders: 'Suborders',
    suborder: 'Suborder',
    promotion: 'Promotion',
    promotionType: 'Promotion Type',
    promotionValue: 'Promotion Value',
    total: 'Total',
    tableNumber: 'Table Number',
    paid: 'Paid',
    quantity: 'Quantity',
    product: 'Product',
    price: 'Price',
    note: 'Note',
    sum: 'Sum',
    searchProducts: 'Search products',
    taxes: 'Taxes',
    points: 'Points',
    pointsRedemption: 'Points to Redeem',
    pointsUsed: 'Points Used',
    orderType: 'Order Type',
    itemsSubtotal: 'Items Subtotal',
    subordersSubtotal: 'Suborders Subtotal',
    serviceFee: 'Service Fee',
    tax: 'Tax',
    receipt: 'Receipt',
    order: 'Order',
    type: 'Type',
    paymentQRCode: 'Payment QR Code',
    checkedIn: 'Checked In',
    enterOtp: 'Enter OTP',
    scanQrCode: 'Scan QR Code',
    scanQR: 'Scan QR Code',
    member: 'Member',
    deliveryPlatform: 'Platform',
  },
  deliveryPlatforms: {
    internal: 'Internal',
    grab: 'Grab',
    shopee: 'Shopee',
    xanhsm: 'Xanh SM',
    customerName: 'Customer Name',
  },
  section: {
    order: 'Order',
    customer: 'Customer',
    shipping_address: 'Shipping Address',
    items: 'Items',
    total: 'Totals',
  },
  orderTypes: {
    dineIn: 'Dine In',
    takeaway: 'Takeaway',
    delivery: 'Delivery',
  },
  promotion: {
    none: 'None',
    percentage: 'Percentage',
    fixed: 'Fixed Amount',
  },
  notification: {
    ready_success: 'Order marked as ready',
    ready_error: 'Error: Could not mark order as ready',
    cancel_success: 'Order cancelled',
    cancel_error: 'Error: Could not cancel order',
    deliver_success: 'Order delivered',
    deliver_error: 'Error: Could not deliver order',
  },
  tabs: {
    ordered: 'Ordered',
    ready: 'Ready',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  },
  status: {
    ordered: 'Ordered',
    ready: 'Ready',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
  },
  filters: {
    dateGte: 'From Date',
    dateLte: 'To Date',
    totalGte: 'Min Total',
  },
  versions: {
    modern: 'Modern',
    legacy: 'Legacy',
    active: 'Active',
  },
  };
